/* ==========================================================================
   dtc-collection.js, catalogue-page progressive enhancement.

   Everything on the collection / search pages works with JavaScript disabled:
     · sorting is a real GET <form> with a real submit button
     · tag filters are real <a> links
     · pagination is real <a> links

   This file only removes a step: it submits the sort form on change and
   hides the now-redundant "Go" button. Nothing else.
   ========================================================================== */
(function () {
  'use strict';

  var DTC = window.DTC;
  if (!DTC || !DTC.register) return;

  DTC.register('catalogue', {
    init: function (root) {
      var form = root.querySelector('[data-dtc-sort-form]');
      if (!form) return;

      var select = form.querySelector('select[name="sort_by"]');
      var go = form.querySelector('[data-dtc-sort-go]');
      if (!select) return;

      if (go) go.classList.add('is-auto');

      var offChange = DTC.on(select, 'change', function () {
        // requestSubmit keeps native validation/behaviour; fall back to submit.
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });

      return function cleanup() {
        offChange();
        if (go) go.classList.remove('is-auto');
      };
    }
  });
})();
